import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {configuredDirectionByLanguage} from "../../resources/direction";
import {getTokenAuth} from "../../services/loginService";
import {checkVaucherNumber, downloadTicket, getIssuesTickets} from "../../services/VoucerPortalService";
import {RESPONSE_STATUS} from "../../constants";



const lang = localStorage.removeItem('userLanguage') || process.env.REACT_APP_DEFAULT_LANG;
const initialState = {
  indexPage : 0,
  classes:null,
  isUpdateToken:false,
  csrfToken:{response: {},status:RESPONSE_STATUS.Unset},
  voucherValidation:{response:{},status:RESPONSE_STATUS.Unset},
  IssueTickets:{response:{},status:RESPONSE_STATUS.Unset},
  downloadTicketResponse:{response:{},status:RESPONSE_STATUS.Unset},
  voucher_no: ""

  // Other initial state properties
};

configuredDirectionByLanguage(lang);
export const setCSRFToken  = createAsyncThunk(
  'token',
  async (secrectKey,thunkApi) => {
    return getTokenAuth(secrectKey,thunkApi);
  }
);


export const VoucherValidation = createAsyncThunk(
  'VoucherValidation',
  async (body, thunkApi) => {
    return checkVaucherNumber(body,thunkApi);
  }
);

export const IssueTickets = createAsyncThunk(
  'issueTickets',
  async (body, thunkApi) => {
    const state = thunkApi.getState();
    return getIssuesTickets(state.VoucherPortalFormReducer.voucher_no,body,thunkApi);
  }
);

export const downloadTicketByUUid = createAsyncThunk(
  'downloadTicket',
  async (uuid_ticket, thunkApi) => {
    const state = thunkApi.getState();
    return downloadTicket(uuid_ticket,thunkApi);
  }
);

const VoucherPortalFormSlice = createSlice({
  name: 'VoucherPortalForm',
  initialState: initialState,
  reducers: {
    updateStatus(state, action) {
      state.statusLoad.response = action.payload
    },
    updateIndexPage(state, action) {
      state.indexPage = action.payload
    },
    updateToken(state, action) {
      state.isUpdateToken = action.payload
    },
    updateVoucherNumber(state, action) {
      state.voucher_no = action.payload
    },
    updateClasses(state, action) {
      state.classes = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(setCSRFToken.pending, (state, action) => {
      state.csrfToken.status =  RESPONSE_STATUS.Loading
    });
    builder.addCase(setCSRFToken.fulfilled, (state, {payload}) => {
      state.csrfToken.response = payload
      state.csrfToken.status =  RESPONSE_STATUS.Succeeded
      state.isUpdateToken = false
      localStorage.setItem('csrf_token',JSON.stringify(payload.csrf_token))
    });
    builder.addCase(setCSRFToken.rejected, (state, {payload}) => {
      state.csrfToken.response = payload
      state.csrfToken.status =  RESPONSE_STATUS.Error
    })
    builder.addCase(VoucherValidation.pending, (state, action) => {
      state.voucherValidation.status = RESPONSE_STATUS.Loading
    });
    builder.addCase(VoucherValidation.fulfilled, (state, {payload}) => {
      state.voucherValidation.response = payload
      state.voucherValidation.status = RESPONSE_STATUS.Succeeded
      if(payload.csrf_token){
        localStorage.setItem('csrf_token',JSON.stringify(payload.csrf_token))
      }
      if (payload.tickets_issued && payload.passengers){
        state.IssueTickets.response = payload.passengers
      }
    });
    builder.addCase(VoucherValidation.rejected, (state, {payload}) => {
      state.voucherValidation.status = RESPONSE_STATUS.Error
      state.voucherValidation.response = payload
    })
    builder.addCase(IssueTickets.pending, (state, action) => {
      state.IssueTickets.status = RESPONSE_STATUS.Loading
    });
    builder.addCase(IssueTickets.fulfilled, (state, {payload}) => {
      state.IssueTickets.response = payload.data
      state.IssueTickets.status = RESPONSE_STATUS.Succeeded

    });
    builder.addCase(IssueTickets.rejected, (state, {payload}) => {
      state.IssueTickets.status = RESPONSE_STATUS.Error
    })
    builder.addCase(downloadTicketByUUid.pending, (state, action) => {
      state.downloadTicketResponse.status = RESPONSE_STATUS.Loading
    });
    builder.addCase(downloadTicketByUUid.fulfilled, (state, {payload}) => {
      state.downloadTicketResponse.response = payload;
      state.downloadTicketResponse.status = RESPONSE_STATUS.Succeeded
    });
    builder.addCase(downloadTicketByUUid.rejected, (state, {payload}) => {
      state.downloadTicketResponse.status = RESPONSE_STATUS.Error
    })
  }
})

export const {updateClasses,updateToken,updateVoucherNumber,updateStatus,updateIndexPage} = VoucherPortalFormSlice.actions


export const {reducer} = VoucherPortalFormSlice;




